"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconMic = function IconMic(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconMic', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.602 5.86c.323 0 .585.244.585.546V7.5c0 2.231-1.789 4.072-4.1 4.341l-.002 1.128h1.759c.291 0 .533.198.578.458l.008.089c0 .302-.263.546-.586.546H5.156c-.323 0-.586-.244-.586-.546 0-.302.263-.547.586-.547h1.758V11.84c-2.24-.26-3.99-1.998-4.096-4.135L2.812 7.5V6.406c0-.302.263-.547.586-.547.324 0 .586.245.586.547V7.5c0 1.812 1.574 3.281 3.516 3.281s3.516-1.469 3.516-3.281V6.406c0-.302.262-.547.586-.547zM7.5.936c1.294 0 2.344.98 2.344 2.188V7.5c0 1.208-1.05 2.188-2.344 2.188-1.294 0-2.344-.98-2.344-2.188V3.125C5.156 1.917 6.206.937 7.5.937zm0 1.094c-.647 0-1.172.49-1.172 1.094V7.5c0 .604.525 1.094 1.172 1.094.647 0 1.172-.49 1.172-1.094V3.125c0-.604-.525-1.094-1.172-1.094z"
  }));
};

var _default = IconMic;
exports.default = _default;